import axios from 'axios';
import { Storage } from '@stacks/storage';
import { userSession, network, getUserData, authenticatedUserAddress } from './auth';
import { stacksApi, clientNetwork } from '../lib/constants';
import { callReadOnlyFunction, cvToJSON, cvToString, cvToValue, principalCV } from '@stacks/transactions';

export const storage = new Storage({ userSession })
// storage.deleteFile('contacts.json')

export const getTransactions = async (principal, offset = 0) => {
  const { data } = await axios.get(`${stacksApi}/extended/v2/addresses/${principal}/transactions?offset=${offset}`);
  console.log(data);
  return { transactions: data.results, offset: data.offset + data.results.length };
};

// export const getTransactionAmount = async (principal, txid) => {
//   const { data } = await axios.get(`${stacksApi}/extended/v1/address/${principal}/${txid}/with_transfers`);
//   console.log(data);
//   return (data && data.stx_sent && data.stx_received) ? Math.max(parseInt(data.stx_sent, 10), parseInt(data.stx_received, 10)) : 0;
// };

export const getBalance = async (principal) => {
  const { data } = await axios.get(`${stacksApi}/extended/v1/address/${principal}/balances`);
  return parseInt(data.stx.balance, 10);
};

export const getPendingTransactions = async (principal, offset = 0) => {
  const { data } = await axios.get(`${stacksApi}/extended/v1/address/${principal}/mempool?offset=${offset}`);
  return { transactions: data.results, offset: data.offset + data.results.length };
};

export const findUser = async (userName) => {
  const { data } = await axios.get(`${stacksApi}/v1/names/${userName}`)
  // console.log('search result', data)
  return data;
}

export const save = async (data, options) => {
  try {
    const result = await storage.putFile(data.fileName, data.content, options);
    console.log("File Written to Storage: ", data.fileName);
    return { success: true, result }
  } catch (e) {
    console.log('An error occured while trying to save file', e);
    return { success: false, result: {} }

  }
}

export const deleteUploads = async (fileName) => {
  try {
    const result = await storage.deleteFile(fileName);
    return { success: true, result }
  } catch (e) {
    console.log('An error occured while trying to save file', e);
    return { success: false, result: {} }

  }
}

export const fetchData = async (fileName) => {
  try {
    const result = await storage.getFile(fileName, { decrypt: false, verify: false })
    return { success: true, result: JSON.parse(result) }
  } catch (e) {
    return { success: false, result: {} }
  }
}

export const getNames = async (address, blockchain = 'stacks') => {
  try {
    const { names } = (await axios.get(`${stacksApi}/v1/addresses/${blockchain}/${address}`)).data;
    return names.length > 0 ? { success: true, names: names } : { success: false, names: names };
  } catch (e) {
    console.log('Error in get names', e);
    return { success: false, names: [] }
  }
}

async function checkLink(url) { return (await fetch(url)).ok };

export const getSourceUrl = async (btcName, filename, findUrl = false) => {
  try {
    const { zonefile } = (await axios.get(`${stacksApi}/v1/names/${btcName}/zonefile`)).data;
    const profileUrl = new RegExp(/https:\/\/(.*)json/).exec(zonefile)[0];
    const profileJson = (await axios.get(profileUrl)).data;
    const hubUrls = profileJson[0].decodedToken.payload.claim.apps;
    if (!findUrl) {
      return `${hubUrls[window.location.origin]}${filename}`;
    } else {
      if (hubUrls[window.location.origin] && await checkLink(`${hubUrls[window.location.origin]}${filename}`)) {
        return `${hubUrls[window.location.origin]}${filename}`;
      }
      for (const hubUrl of Object.values(hubUrls)) {
        console.log(`${hubUrl}${filename}`)
        if (await checkLink(`${hubUrl}${filename}`)) {
          return `${hubUrl}${filename}`;
        }
      }
      return filename;
    }
  } catch (e) {
    console.log('Error in get source url', e);
    return filename;
  }
}


export const saveMute = async (id, reason) => {
  try {
    // Fetch the existing muted data from the file, or create an empty object if the file does not exist
    let mutesData = {};
    const result = await fetchData('mutedlist.json');
    if (result.success) {
      mutesData = result.result;
    }

    // Append the new key/value entry to the muted data
    mutesData[id] = reason;

    // Save the updated muted data to the file
    const dataToSave = {
      content: JSON.stringify(mutesData),
      fileName: 'mutedlist.json'
    };
    const saveResult = await save(dataToSave);
    if (!saveResult.success) {
      throw new Error('Error while saving mute list');
    }

    return mutesData;
  } catch (e) {
    throw new Error('Error while saving mute list', e);
  }
};

export const removeMute = async (id) => {
  try {
    // Fetch the existing muted data from the file
    const result = await fetchData('mutedlist.json');
    if (!result.success) {
      throw new Error('Error while fetching mute list');
    }

    // Remove the key/value entry with the specified ID
    const mutesData = result.result;
    delete mutesData[id];

    // Save the updated muted data to the file
    const dataToSave = {
      content: JSON.stringify(mutesData),
      fileName: 'mutedlist.json'
    };
    const saveResult = await save(dataToSave);
    if (!saveResult.success) {
      throw new Error('Error while saving mute list');
    }

    return mutesData;
  } catch (e) {
    throw new Error('Error while removing muted', e);
  }
};


export const validateUsersContract = async () => {
  let status = { state: '', txId: '' };
  // const for users address
  const usersAddress = authenticatedUserAddress({ network: clientNetwork });
  const userContractId = `${usersAddress}.derupt-profile`;
  // check contract exist for user
  async function checkMempool() {
    let mempoolActivationStatus, mempool;
    try {
      mempoolActivationStatus = (await axios.get(`${stacksApi}/extended/v1/tx/mempool?sender_address=${usersAddress}`)).data.results;
    } catch (error) { }

    if (mempoolActivationStatus?.length > 0) {
      mempool = mempoolActivationStatus.filter((res) => {
        if (res?.smart_contract && res?.smart_contract?.contract_id === userContractId) {
          status.state = 'mempool';
          status.txId = res?.tx_id;
          return true
        };
        if (res?.contract_call?.contract_id === userContractId && res?.contract_call?.function_name === 'activate-member') {
          status.state = 'activationPending';
          status.txId = res?.tx_id;
          return true;
        }
        return false;
      });
    }

    return (mempool && mempool[0]?.tx_id) ? false : true;
  }

  await checkMempool().then(async (res) => {
    if (res) {
      await axios.get(`${stacksApi}/v2/contracts/source/${usersAddress}/derupt-profile`)
        .then(async () => {

          const activationStatus = cvToValue(await callReadOnlyFunction({
            contractAddress: usersAddress, contractName: 'derupt-profile',
            functionName: 'activation-status', functionArgs: [],
            network: network({ network: clientNetwork }), senderAddress: usersAddress
          }))?.value;
          const activationTx = (await axios.get(`${stacksApi}/extended/v1/contract/${usersAddress}.derupt-profile`)).data;
          status.state = activationStatus;
          status.txId = activationTx?.tx_id;

        })
        .catch(async () => {
          status.state = 'notfound';
          status.txId = '';
        })
    }
  })

  return status;
};